import { c as _c } from "react/compiler-runtime";
/* eslint-disable */

import { useEffect } from "react";
import { useEcomStore } from "@/context/ecom/EcomContext";
const useEcomPage = () => {
  const $ = _c(3);
  const [, dispatch] = useEcomStore() ?? [null, _temp];
  let t0;
  if ($[0] !== dispatch) {
    t0 = () => {
      dispatch({
        type: "SET_ECOMMERCE_PAGE",
        payload: true
      });
      return () => {
        dispatch({
          type: "SET_ECOMMERCE_PAGE",
          payload: false
        });
      };
    };
    $[0] = dispatch;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  useEffect(t0, t1);
};
export default useEcomPage;
function _temp() {
  console.warn("Dispatch called but store not available");
}